<template>
  <div class="jessibuca-player-container">
    <!-- 播放器容器 -->
    <div ref="videoDom" class="jessibuca-dom"></div>
  </div>
</template>

<script>
export default {
  name: "CommonPlayer",
  props: {
    idIndex: {
      type: Number,
      default: 999,
    },
    videoUrl: {
      type: String,
      required: true,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    // 自定义 Jessibuca 配置
    configFa: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      jessibuca: null,
      errorCount: 0, // 错误计数
      MAX_ERROR_COUNT: 3, // 最大允许错误次数
      errorFlag: false, // 错误flag
      // 默认 Jessibuca 配置
      defaultConfig: {
        loadingText: "加载中...",
      },
    };
  },
  computed: {
    // decoder 路径优先取 Vue.use 时传入的 options.decoder，否则取默认值
    decoderPath() {
      return (
        (this.$jessibucaConfig && this.$jessibucaConfig.decoder) ||
        "/js/Jessibuca/decoder.js"
      );
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.videoUrl) {
        this.initPlayer();
      }
    });
  },
  watch: {
    videoUrl: {
      async handler(newUrl) {
        if (this.jessibuca && newUrl) {
          try {
            this.jessibuca.pause();
            this.jessibuca.destroy();
          } catch (e) {
            console.error("销毁播放器时出错", e);
          }
          this.jessibuca = null;
          await this.initPlayer();
        }
      },
    },
  },
  methods: {
    async initPlayer() {
      // 检查 $player 是否存在
      if (!this.$player) {
        console.error("Jessibuca 未正确挂载，请检查 main.js 配置");
        return;
      }
      // 确保 videoUrl 有值再初始化
      if (!this.videoUrl) {
        console.warn("videoUrl 为空，暂不初始化播放器");
        return;
      }
      console.log("Jessibuca 已正确挂载", this.$refs.videoDom);
      const config = Object.assign(
        {},
        this.defaultConfig,
        { decoder: this.decoderPath },
        this.configFa
      );
      this.jessibuca = new this.$player({
        container: this.$refs.videoDom,
        ...config,
      });

      this.jessibuca.on("videoInfo", info => {
        console.log("[视频信息]", info);
      });

      this.jessibuca.on("error", e => {
        console.error("播放出错", e);
        this.errorCount++;
        this.errorFlag = true;
        // 若超过最大错误次数，主动销毁播放器
        if (this.errorCount >= this.MAX_ERROR_COUNT) {
          this.destroyPlayer();
          console.warn("播放器连续报错，已主动销毁防止性能问题");
        }
        this.$emit("player-created", {
          index: this.idIndex,
          player: this.jessibuca,
          err: e,
        });
      });
      this.jessibuca.on("play", () => {
        this.$emit("player-created", {
          index: this.idIndex,
          player: this.jessibuca,
          err: null,
        });
      });
      try {
        if (this.autoplay) {
          await this.jessibuca.play(this.videoUrl);
        }
      } catch (error) {
        console.error("播放视频时出错", error);
      }
    },
    destroyPlayer() {
      if (this.jessibuca) {
        this.jessibuca.destroy();
        this.jessibuca = null;
      }
    },
  },
  // 销毁组件时销毁视频
  beforeDestroy() {
    this.destroyPlayer();
  },
};
</script>

<style scoped>
.jessibuca-player-container {
  width: 100%;
  height: 100%;
  min-height: 169px;
  min-width: 300px;
  background: #000;
}
.jessibuca-dom {
  width: 100%;
  height: 100%;
}
</style>
